import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { ConditionalFormModule } from '../conditional-form/conditional-form.module';

//Kendo Imports
import { GridModule, DataBindingDirective } from '@progress/kendo-angular-grid';

import { InvestmentWizardComponent } from './investment-wizard/investment-wizard.component';
import { RiskToleranceComponent } from '../risk-tolerance/risk-tolerance.component';
import { FundingOptionsComponent } from '../funding-options/funding-options.component';
import { FundsDialogComponent } from '../funds-dialog/funds-dialog.component';
import { MultiDialogComponent } from '../multi-dialog/multi-dialog.component';
import { FamilyDialogComponent } from '../family-dialog/family-dialog.component';
import { CustomModelDialogComponent } from './custom-model-dialog/custom-model-dialog.component';
import { ValidationDialogComponent } from './validation-dialog/validation-dialog.component';
import { FundLookupDialogComponent } from './fund-lookup-dialog/fund-lookup-dialog.component';
import { ProductSearchComponent } from './product-search/product-search.component';
import { GenerateAlternativesDialogComponent } from './generate-alternatives-dialog/generate-alternatives-dialog.component';

//Services
import { AuthService } from '../services/auth-service.service';
import { RightBridgeApiService } from '../services/right-bridge-api.service';
import { InvestmentWizardService } from './services/investment-wizard-service.service';

import { IwRouting } from './investment-wizard-routing.module';
import { ProductGridComponent } from './product-grid/product-grid.component';
import { MaskitoDirective } from '@maskito/angular';
import { generate } from 'rxjs';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    IwRouting,
    FormsModule,
    ReactiveFormsModule,
    ConditionalFormModule,
    NgxDatatableModule,
    GridModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circle,
      backdropBackgroundColour: 'rgba(0, 0, 0, 0.3)',
      fullScreenBackdrop: true,
      backdropBorderRadius: '0',
      primaryColour: 'rgb(38, 91, 151)',
      secondaryColour: 'rgba(38, 91, 151, 0.2)',
      tertiaryColour: '#265b97',
    }),
    SharedComponentsModule,
    MaskitoDirective,
    DataBindingDirective,
  ],
  declarations: [
    RiskToleranceComponent,
    FundingOptionsComponent,
    FundsDialogComponent,
    MultiDialogComponent,
    FamilyDialogComponent,
    InvestmentWizardComponent,
    CustomModelDialogComponent,
    ValidationDialogComponent,
    FundLookupDialogComponent,
    ProductSearchComponent,
    ProductGridComponent,
    GenerateAlternativesDialogComponent,
  ],
  providers: [
    RightBridgeApiService,
    InvestmentWizardService,
    AuthService,
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class InvestmentWizardModule {}
